
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { onBeforeRouteUpdate, useRoute } from "vue-router";
import Avatar from "vue-avatar-component";
import FeedsWidget2 from "@/components/widgets/feeds/Widget2.vue";

export default defineComponent({
  name: "profile-settings",
  components: {
    Avatar,
    FeedsWidget2,
  },
  methods: {
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },

  setup() {
    const route = useRoute();
    const store = useStore();
    let id = route.params.id;
    onBeforeRouteUpdate((to, from, next) => {
      console.log("beforeRouteUpdate");
      id = to.params.id;
      verTicket();
      next();
    });
    onMounted(() => {
      setCurrentPageBreadcrumbs("Mi Solicitud", ["Páginas", "Dashboard"]);
      verTicket();
    });
    const verTicket = () => {
      store
        .dispatch(Actions.GET_TICKET, id)
        .then(() => {
          loading = ref(false);
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getTicketErrors);
        });
      store.dispatch(Actions.UPD_LEIDO_TICKET, id);
    };
    const currentTicket = computed(() => {
      return store.getters.currentTicket;
    });
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    let loading = ref(true);
    return {
      currentTicket,
      currentUser,
      store,
      verTicket,
    };
  },
});
